// src/com/tsr/TransPlanTsrViewSupplyGeneral.js
import React from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { TableContainer, Table, TableHead, TableBody, TableCell, TableRow } from '@mui/material';
import { AppWord, AppStyle } from '../../value/AppConst';
import { useReactiveVar } from '@apollo/client';
import { transPlanTsrItemRepo } from '../../value/AppModel';
import { CenterCell } from '../../common/TopStyle';

const TitleCellBg = '#def';

const TitleCell = styled(TableCell)({
    backgroundColor: TitleCellBg,
    color: AppStyle.PrimaryRGB,
    fontWeight: 'bold',
    textAlign: 'center',
});
const SubTitleCell = styled(TableCell)({
    backgroundColor: TitleCellBg,
    fontWeight: 'bold',
    textAlign: 'center',
});

/**
 * 상온센터(안성ADC제외) 물류집기 보기.
 * PC 버전: TransPlanTsrEditSupplyGeneral
 * @param {*} param0 
 * @returns 
 */
export default function TransPlanTsrViewSupplyGeneral() {
    const item = useReactiveVar(transPlanTsrItemRepo);

    return (
        <Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>Pallet</TitleCell>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>Roll Cage</TitleCell>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>B2B Pallet</TitleCell>
                            <TitleCell rowSpan={2} size={AppWord.SMALL}>기타</TitleCell>
                        </TableRow>
                        <TableRow>
                            <SubTitleCell size={AppWord.SMALL}>KPP</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>AJU</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>일반</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>점간대출</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>KPP</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>AJU</SubTitleCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <CenterCell>{item.aPalKpp}</CenterCell>
                            <CenterCell>{item.aPalAju}</CenterCell>
                            <CenterCell>{item.aRollN}</CenterCell>
                            <CenterCell>{item.aRollJum}</CenterCell>
                            <CenterCell>{item.aB2bKpp}</CenterCell>
                            <CenterCell>{item.aB2bAju}</CenterCell>
                            <CenterCell>{item.aEtc}</CenterCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{
                                    color:AppStyle.PrimaryRGB, fontWeight:'bold', textAlign:'center',
                                }}
                            >Pallet Total:</TableCell>
                            <TableCell
                                style={{textAlign:'center', backgroundColor: '#eee'}}
                            >{item.aPalKpp + item.aPalAju}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Box style={{height:20}}></Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TitleCell colSpan={3} size={AppWord.SMALL}>Other Pallet</TitleCell>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>고가상품</TitleCell>
                            <TitleCell rowSpan={2} size={AppWord.SMALL}>Tray</TitleCell>
                        </TableRow>
                        <TableRow>
                            <SubTitleCell size={AppWord.SMALL}>특정</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>점간대출</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>Trunking</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>단프라</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>롤케이지</SubTitleCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <CenterCell>{item.aOpSpec}</CenterCell>
                            <CenterCell>{item.aOpJum}</CenterCell>
                            <CenterCell>{item.aOpTrunc}</CenterCell>
                            <CenterCell>{item.aHiDanpra}</CenterCell>
                            <CenterCell>{item.aHiRoll}</CenterCell>
                            <CenterCell>{item.aTray}</CenterCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}